import { render } from "./BlFormFieldChoice.vue?vue&type=template&id=642709da"
import script from "./BlFormFieldChoice.vue?vue&type=script&lang=js"
export * from "./BlFormFieldChoice.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__